<template>
  <el-select
    v-model="selectedValue"
    :placeholder="placeholder"
    style="width: 100%"
    clearable
    filterable
    :multiple="multiple"
    :disabled="disabled"
    @change="select"
  >
    <el-option
      v-for="item in options"
      :key="item[option.Id]"
      :label="item[option.label]"
      :value="item[option.Id]"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  name: 'ShelfSelect',
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    option: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          Id: 'Id',
        }
      },
    },
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    locationOptions: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      selectedValue: this.value,
      options: [],
    }
  },
  watch: {
    // locationOptions: {
    //   deep: true,
    //   handler(newValue) {
    //     if (newValue.length > 0) {
    //       this.options = newValue
    //     }
    //   },
    // },

    selectedValue(newValue) {
      this.$emit('input', newValue)
    },
    value(newValue) {
      this.selectedValue = newValue
    },
  },
  created() {
    if (this.locationOptions.length > 0) {
      this.options = this.locationOptions
      return
    }
    this.fetchOptions()
  },
  methods: {
    select(value) {
      console.log(value)
      if (this.multiple) {
        let arr = []
        value.forEach((item) => {
          let obj = this.options.find((item) => {
            return item.Id == item
          })
          arr.push(obj)
        })
        this.$emit('select', arr)
      } else {
        let obj = this.options.find((item) => {
          return item.Id == value
        })
        this.$emit('select', obj)
      }
    },
    async fetchOptions() {
      try {
        await this.$http.post(this.url, this.data).then((res) => {
          if (res.Success) {
            this.options = res.Data
          } else {
            this.options = []
          }
        })
      } catch (error) {
        console.error('Error fetching options:', error)
      }
    },
  },
}
</script>
